/**
 * QUANTOS PRODUTOS UM FLY LEVA — de 1 a 3 (o fly de sempre) ou exatamente 12 (o catalogo).
 *
 * Pedido do Ruan em 14/09/2026, na tela da Campanha de fly por etiqueta: *"ja que vamos enviar
 * apenas um fly por semana, seria interessante enviar um catalogo de uma pagina com varios
 * produtos"*. Ele trouxe como referencia um catalogo da Tambasa (12 produtos, 4 x 3), aprovou a
 * amostra de 12 contra as de 6 e 9 e decidiu as duas regras que moram aqui:
 *   • **o catalogo e' de 12 EXATOS** — de 4 a 11 nao sai nada, e a tela diz por que;
 *   • **a legenda do catalogo leva so' o texto dele** (a arte ja mostra codigo, nome e preco).
 *
 * Vive em `@fiodecobre/shared` pelo motivo do `marca-loja`: a TELA precisa da resposta pra dizer
 * o que falta antes do clique, e o SERVIDOR recusa de verdade — nas rotas do chat, do fly
 * guardado e da campanha. Copias separadas divergiriam no primeiro ajuste.
 *
 * ⚠️ O banco tem a mesma regra num CHECK de `flys_salvos` (migration 0291). Mexeu aqui, mexe la.
 */

/** Teto do fly de sempre: 1 a 3 produtos, lado a lado no quadro de 1080. */
export const FLY_MAX_PRODUTOS = 3;

/** O catalogo de uma pagina: 4 colunas x 3 linhas, em pe. */
export const FLY_CATALOGO_PRODUTOS = 12;

/** Esta quantidade vira o catalogo de uma pagina? */
export function ehCatalogoFly(qtd: number): boolean {
  return qtd === FLY_CATALOGO_PRODUTOS;
}

/**
 * O que falta pra esta quantidade virar um fly — `null` quando ja vira.
 *
 * ⚠️ O texto e' pra TELA: ele diz o gesto que resolve, nao so' que esta errado (botao apagado e
 * mudo e' beco sem saida — CLAUDE.md § UI).
 */
export function motivoQuantidadeFly(qtd: number): string | null {
  if (qtd >= 1 && qtd <= FLY_MAX_PRODUTOS) return null;
  if (ehCatalogoFly(qtd)) return null;
  if (qtd <= 0) return 'Escolha pelo menos 1 produto.';
  if (qtd < FLY_CATALOGO_PRODUTOS) {
    const faltam = FLY_CATALOGO_PRODUTOS - qtd;
    return `O fly leva até ${FLY_MAX_PRODUTOS} produtos; o catálogo, exatamente ${FLY_CATALOGO_PRODUTOS}. `
      + `Faltam ${faltam} para o catálogo ou tire ${qtd - FLY_MAX_PRODUTOS} para o fly.`;
  }
  return `O catálogo leva exatamente ${FLY_CATALOGO_PRODUTOS} produtos — tire ${qtd - FLY_CATALOGO_PRODUTOS}.`;
}

export function quantidadeFlyValida(qtd: number): boolean {
  return motivoQuantidadeFly(qtd) === null;
}

/**
 * Trunca uma lista de produtos ao MAIOR formato que a quantidade alcança — pro dia em que a
 * campanha "Somente Texto" (sem teto de quantidade) DESLIGA e a lista que sobrou tem produtos
 * demais pro fly com arte. Regra dele: 12 ou mais vira o catálogo de 12; de 4 a 11 vira o fly de
 * 3; 1 a 3 fica como está. Sempre os PRIMEIROS da lista, na ordem em que foram marcados.
 *
 * ⛔ Devolve os DOIS pedaços — quem entra e quem fica de fora — porque a tela precisa dos dois
 * pra escrever o aviso ANTES do disparo ("vão 12 — os 8 últimos ficam de fora"). Truncar calado
 * é proibido (CLAUDE.md § Metodo).
 */
export function truncarParaFormatoFly<T>(itens: T[]): { entram: T[]; fora: T[] } {
  const total = itens.length;
  const limite = total >= FLY_CATALOGO_PRODUTOS
    ? FLY_CATALOGO_PRODUTOS
    : Math.min(total, FLY_MAX_PRODUTOS);
  return { entram: itens.slice(0, limite), fora: itens.slice(limite) };
}
